import React, { forwardRef } from 'react'
import './contact.scss'

const Contact = forwardRef((props, ref) => {
  return (
    <div className='contact_outer_div' ref={ref}>
      <h1>Contact</h1>

      <div style={{ width: '70%' }}>
        <div
          className='contact_div'
          onClick={() => window.open('mailto:sam.varg.2003@gmail.com')}
        >
          <img
            src={process.env.PUBLIC_URL + '/images/mail.svg'}
            className='contact_icon'
            alt=''
          />
          <span>sam.varg.2003@gmail.com</span>
        </div>

        <div
          className='contact_div'
          onClick={() =>
            window.open('https://linkedin.openinapp.co/p0yl3', '_blank')
          }
        >
          <img
            src={process.env.PUBLIC_URL + '/images/linkedin.svg'}
            className='contact_icon'
            alt=''
          />
          <span>sam-varghese2003</span>
        </div>

        <div
          className='contact_div'
          onClick={() =>
            window.open('https://www.instagram.com/sam_varghese2003', '_blank')
          }
        >
          <img
            src={process.env.PUBLIC_URL + '/images/instagram.svg'}
            className='contact_icon'
            alt=''
          />
          <span>sam_varghese2003</span>
        </div>
      </div>
    </div>
  )
})

export default Contact
